import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'
import { getAppName, getNativeInfo } from '../jsbridge'
import { ILocal, localBizMap,transCountryToStoreArea } from '../utils/locales'
import { normalizeAppName } from '../utils/appName'

const MAX_RETRY_COUNT = 3
const RETRY_INTERVAL = 300
let retryCount = 0

const getInfo = async () => {
  try {
    const nativeInfo = await getNativeInfo()
    if (!nativeInfo?.appName) {
      throw new Error('getNativeInfo failed')
    }
    const appName = normalizeAppName(await getAppName())
    retryCount = 0
    return { nativeInfo, appName }
  } catch (error) {
    setTimeout(() => {
      console.log('🚀 ~ getInfo ~ error:', error)
    }, 2000)
    if (retryCount < MAX_RETRY_COUNT) {
      retryCount++
      await new Promise(resolve => setTimeout(resolve, RETRY_INTERVAL))
      return getInfo()
    }
    return null
  }
}

// 修复cookie上的数据
export const useFixCookie = () => {
  const [isReady, setIsReady] = useState(false)
  // 更新cookie之前的cookie值
  const [beforeCookies, setBeforeCookies] = useState<Cookies.CookieAttributes | null>(null)

  function getAreaFromUrlPath() {
    const path = window.location.pathname
    const splitPath = path.split('/')
    // n代表operation项目，s代表store项目
    const projectCode = splitPath[1]
    const countryCode = splitPath[2]

    if (countryCode) {
      // 如果是operation项目，需要转换国家码
      return projectCode === 'n' ? localBizMap[countryCode! as ILocal] || 'us' : countryCode
    } else {
      return 'us'
    }
  }

  useEffect(() => {
    setBeforeCookies({
      country: Cookies.get('country'),
      web_country: Cookies.get('web_country'),
      store_area: Cookies.get('store_area'),
      token: Cookies.get('token'),
      gtoken: Cookies.get('gtoken'),
      app_name: Cookies.get('app_name'),
      openudid: Cookies.get('openudid'),
      access_token: Cookies.get('access_token'),
      categories: Cookies.get('categories'),
    })
    getInfo()
      .then(info => {
        console.log('🚀 ~ getInfo.then ~ info:', info)

        // 在开发环境下或者有调试标识下不清除cookie
        const isDevelopment = process.env.NODE_ENV === 'development';
        const hasMockJsBridge = window.location.search.includes('_MOCK_JS_BRIDGE=1');
        const shouldClearCookies = !isDevelopment && !hasMockJsBridge;
        if (shouldClearCookies) {
          Cookies.remove('country')
          Cookies.remove('web_country')
          Cookies.remove('store_area')
          Cookies.remove('token')
          Cookies.remove('gtoken')
          Cookies.remove('app_name')
          Cookies.remove('openudid')
          Cookies.remove('access_token')
          Cookies.remove('categories')
        }

        // 修复cookie兼容以下情况
        // 1.在clean/life APP中jsbridge报错info为null
        // 2.在clean/life APP中jsbridge不报错但是设置的info信息不对
         // 3.在web落地页中info为{}，没有gtoken和token
        if (!info || !info.nativeInfo || !info.appName) {
          Cookies.set('store_area', getAreaFromUrlPath(), { expires: 30 })
          setIsReady(true)
          return
        }
        
        const { nativeInfo, appName } = info

        Cookies.set('country', nativeInfo?.country.toLowerCase(), { expires: 30 }) // 30天有效期
        Cookies.set('web_country', nativeInfo?.country.toLowerCase(), { expires: 30 }) // 30天有效期
        Cookies.set('store_area', transCountryToStoreArea(nativeInfo?.country?.toLowerCase()), { expires: 30 }) // 30天有效期
        Cookies.set('token', nativeInfo?.token ?? '', { expires: 30 }) // 30天有效期
        Cookies.set('gtoken', nativeInfo?.gtoken ?? '', { expires: 30 }) // 30天有效期
        Cookies.set('app_name', appName ?? '', { expires: 30 }) // 30天有效期
        Cookies.set('openudid', nativeInfo?.openudid ?? '', { expires: 30 }) // 30天有效期
        Cookies.set('access_token', nativeInfo?.accessToken ?? '', { expires: 30 }) // 30天有效期
        Cookies.set('categories', (nativeInfo.categories ?? []).join(','), { expires: 30 })
        setIsReady(true)
      })
      .catch(() => {
        console.log('🚀 ~ getInfo.catch ~ info:', 'this is catch')
        Cookies.set('store_area', getAreaFromUrlPath(), { expires: 30 })
        setIsReady(true)
      })
  }, [])
  return { isReady, beforeCookies }
}
